import React, { useState, useEffect, useRef } from 'react';
import './MusicPlayer.css';

export default function MusicPlayer({ song, playlist, onNext, onPrev, onClose }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(70);
  const [isMuted, setIsMuted] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const intervalRef = useRef(null);
  const TOTAL_DURATION = 30;

  useEffect(() => {
    setIsPlaying(true);
    setProgress(0);
    setCurrentTime(0);
  }, [song]);

  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        setCurrentTime(prev => {
          const next = prev + 0.1;
          if (next >= TOTAL_DURATION) {
            onNext && onNext();
            return 0;
          }
          setProgress((next / TOTAL_DURATION) * 100);
          return next;
        });
      }, 100);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPlaying, onNext]);

  const togglePlay = () => setIsPlaying(!isPlaying);
  const toggleMute = () => setIsMuted(!isMuted);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  if (!song) return null;

  return (
    <div className="music-player">
      <div className="player-blur" style={{ backgroundImage: `url(${song.cover})` }} />
      <div className="player-content">
        <div className="player-left">
          <img className="player-cover" src={song.cover} alt={song.album} />
          <div className="player-song-info">
            <h4 className="player-title">{song.title}</h4>
            <p className="player-artist">{song.artist}</p>
            <p className="player-album">{song.album} ({song.year})</p>
          </div>
        </div>

        <div className="player-center">
          <div className="player-controls">
            <button className="ctrl-btn" onClick={onPrev} title="上一首">⏮</button>
            <button className="ctrl-btn play-btn" onClick={togglePlay} title={isPlaying ? '暂停' : '播放'}>
              {isPlaying ? '❚❚' : '▶'}
            </button>
            <button className="ctrl-btn" onClick={onNext} title="下一首">⏭</button>
          </div>
          <div className="progress-bar">
            <span className="time">{formatTime(currentTime)}</span>
            <div className="progress-track">
              <div className="progress-fill" style={{ width: `${progress}%` }} />
            </div>
            <span className="time">{formatTime(TOTAL_DURATION)}</span>
          </div>
        </div>

        <div className="player-right">
          <div className="volume-control">
            <button className="ctrl-btn" onClick={toggleMute} title={isMuted ? '取消静音' : '静音'}>
              {isMuted ? '🔇' : volume > 50 ? '🔊' : volume > 0 ? '🔉' : '🔇'}
            </button>
            <input
              type="range"
              min="0"
              max="100"
              value={isMuted ? 0 : volume}
              onChange={e => { setVolume(Number(e.target.value)); setIsMuted(false); }}
              className="volume-slider"
            />
          </div>
          <button className="ctrl-btn close-btn" onClick={onClose} title="关闭">✕</button>
        </div>
      </div>
    </div>
  );
}
